<template>
  <div :class="['dropdown-menu', `dropdown-${dropdownPosition}`]" :style="transform" ref="dropdown">
    <div class="dropdown-tail-wrapper" v-if="displayTail">
      <!--            <div class="dropdown-tail" ref="tail"></div>-->
    </div>
    <div class="dropdown-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
const POSITIONS = { bottom: 'bottom', left: 'left', top: 'top', right: 'right' }
const TAIL_SIZE = 10

export default {
  name: 'app-dropdown',
  props: {
    dstEl: HTMLElement,
    dropdownPosition: {
      type: String,
      default: POSITIONS.bottom,
      validator(value) {
        return Object.keys(POSITIONS).indexOf(value) !== -1
      }
    },
    displayTail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentOffset: { top: 0, left: 0 },
      intervalId: null
    }
  },
  computed: {
    transform() {
      return { transform: `translate(${this.currentOffset.left}px, ${this.currentOffset.top}px)` }
    },
    dropdownCorrection() {
      let correction = { top: 0, left: 0 }
      let dstSize = this.getElSize(this.dstEl)
      let dropdownSize = this.getElSize(this.$refs.dropdown)
      let documentSize = {
        width: document.documentElement.scrollWidth,
        height: document.documentElement.scrollHeight
      }

      let heightCorrectionEnabled = true
      let widthCorrectionEnabled = true

      if (documentSize.height < dropdownSize.height) {
        heightCorrectionEnabled = false
      }

      if (documentSize.width < dropdownSize.width) {
        widthCorrectionEnabled = false
      }

      // fill correction
      if (this.dropdownPosition === POSITIONS.bottom) {
        correction.top = heightCorrectionEnabled ? Math.round(dstSize.height + (TAIL_SIZE - 2) / 2) : 0
        correction.left = widthCorrectionEnabled ? Math.round((dstSize.width - dropdownSize.width) / 2) : 0
      }

      if (this.dropdownPosition === POSITIONS.right) {
        correction.top = heightCorrectionEnabled ? Math.round(-TAIL_SIZE / 2) : 0
        correction.left = widthCorrectionEnabled ? Math.round(dstSize.width + (TAIL_SIZE - 2) / 2) : 0
      }
      // todo: add left & top!

      // check window overflow still over flow
      let rightOverflow = documentSize.width - (this.dstEl.getBoundingClientRect().left + dropdownSize.width / 2)
      if (rightOverflow < 0) {
        correction.left += Math.round(rightOverflow) - 40
      }

      return correction
    }
  },
  methods: {
    getElSize(el) {
      let bounds = el.getBoundingClientRect()
      return {
        height: bounds.height,
        width: bounds.width
      }
    },
    getElementPosition(el) {
      if (el && el instanceof HTMLElement) {
        let bounds = el.getBoundingClientRect()
        return { top: Math.round(document.body.scrollTop + bounds.top), left: Math.round(bounds.left) }
      }
      return { top: 0, left: 0 }
    },
    getElementsDeltaPostion() {
      let dst = this.getElementPosition(this.dstEl)
      let dropdown = this.getElementPosition(this.$refs.dropdown)
      return {
        top: dst.top - dropdown.top + this.dropdownCorrection.top,
        left: dst.left - dropdown.left + this.dropdownCorrection.left
      }
    },
    setOffset() {
      if (this.dstEl) {
        let delta = this.getElementsDeltaPostion()
        this.currentOffset.left += delta.left
        this.currentOffset.top += delta.top
      }
    }
  },
  mounted() {
    this.setOffset()
    this.intervalId = setInterval(this.setOffset, 300)
    this.$nextTick(function() {
      window.addEventListener('scroll', this.setOffset, true)
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.setOffset)
    clearInterval(this.intervalId)
  }
}
</script>

<style scoped lang="scss">
$dd: '.dropdown';
$tail-size: 17px;
#{$dd}-menu {
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  padding: 0;
}

#{$dd}-tail-wrapper {
  position: absolute;

  #{$dd}-bottom > & {
    transform-origin: 100% 100%;
    top: -18px;
    height: 18px;
    width: 100%;
  }

  #{$dd}-right > & {
    transform-origin: 100% 100%;
    left: -18px;
    width: 18px;
    height: 100%;
  }
}

#{$dd}-tail {
  background: linear-gradient(to top right, rgba(0, 0, 0, 0.1) 50%, transparent 50%);

  #{$dd}-bottom & {
    transform: rotate(135deg);
    transform-origin: 100% 100%;
    right: auto;
    left: calc(50% - #{$tail-size} - 12px);
    top: 0;
    bottom: 100%;
  }

  #{$dd}-right & {
    transform: rotate(45deg);
    transform-origin: 100% 100%;
    right: 100%;
    left: 0;
    top: calc(#{$tail-size});
    bottom: auto;
  }

  &,
  &:after {
    position: absolute;
    width: #{$tail-size};
    height: #{$tail-size};
  }

  &:after {
    content: '';
    bottom: 1px;
    left: 1px;
    background: #fff;
  }
}

#{$dd}-content {
  position: relative;
}
</style>
